import { RootState } from "../root.reducer";

export const checkoutStepsSelector = (state: RootState) => state.checkoutSteps;

export const getCurrentStepSelector = (state: RootState) => {
  const stepsKeys = Object.keys(state.checkoutSteps.steps);
  const currentStepKey = stepsKeys[
    state.checkoutSteps.currentStep
  ] as keyof typeof state.checkoutSteps.steps;
  return state.checkoutSteps.steps[currentStepKey];
};

export const getCurrentStepKeySelector = (state: RootState) => {
  const stepsKeys = Object.keys(state.checkoutSteps.steps);
  return stepsKeys[state.checkoutSteps.currentStep];
};

export const getShouldRevalidate = (state: RootState) => {
  return state.checkoutSteps.shouldRevalidate;
};
